export default __webpack_public_path__ + "2ff7ed54b9b84f8d3df550ed33bed68c.png";